/**
 * Thin wrappers around localStorage. The key names are shared with the legacy portal so a
 * session created there (or via the website hand-off flow) keeps working here.
 */
export const STORAGE_KEYS = {
  authToken: 'Authorization',
  websiteType: 'website_type',
  timezone: 'timezone',
  rememberedLogin: 'access',
  boardView: 'selectedListingView',
  sidebarCollapsed: 'vc.sidebarCollapsed',
  skipProfileForNow: 'skipProfileForNow',
  boardFilters: 'vc.boardFilters',
} as const

type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS]

export function readStorage(key: StorageKey): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function writeStorage(key: StorageKey, value: string | null): void {
  try {
    if (value === null) {
      window.localStorage.removeItem(key)
    } else {
      window.localStorage.setItem(key, value)
    }
  } catch {
    // Storage can be unavailable (private mode, blocked). The app must keep working without it.
  }
}

export function readJson<T>(key: StorageKey): T | null {
  const raw = readStorage(key)
  if (!raw) return null
  try {
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}
